import { actionTypes } from 'actions/actionTypes'
import { getBasketIsPortionSizeViewVisible, getBasketIsShowDetailsViewFirst } from 'selectors/basket'
import { getIsLandOnMenuEnabled } from 'selectors/features'
import { getIsAuthenticated } from 'selectors/auth'

const boxSummaryViews = {
  POSTCODE: 'POSTCODE',
  DELIVERY_SLOT: 'DELIVERY_SLOT',
  DETAILS: 'DETAILS',
  PORTION_SIZE: 'PORTION_SIZE'
}

function getCurrentBoxSummaryView(state) {
  const postcode = state.basket.get('postcode')
  const deliveryDaysError = Boolean(state.error.get(actionTypes.BOXSUMMARY_DELIVERY_DAYS_RECEIVE))
  const postcodePending = state.basket.get('postcodePending')
  const slotId = state.basket.get('slotId')
  const orderId = state.basket.get('orderId')
  const isLandOnMenuFeatureEnabled = getIsLandOnMenuEnabled(state)
  const isAuthenticated = getIsAuthenticated(state)
  const isPortionSizeViewVisible = getBasketIsPortionSizeViewVisible(state)
  const isShowDetailsViewFirst = getBasketIsShowDetailsViewFirst(state)
  const menuPending = state.menuReceiveMenuPending || state.pending.get(actionTypes.MENU_BOX_PRICES_RECEIVE, false) || state.pending.get(actionTypes.MENU_FETCH_DATA, false)

  const isLandOnMenuEnabled = !isAuthenticated && isLandOnMenuFeatureEnabled && isShowDetailsViewFirst

  const showPostcode = (!postcode || deliveryDaysError || postcodePending) && !orderId

  const showDeliverySlot = ((!showPostcode && !slotId) || menuPending) && !orderId

  const showDetailsView = !showPostcode && !showDeliverySlot

  const showPortionsSizeView = !showPostcode && !showDeliverySlot && isPortionSizeViewVisible

  let currentView

  if (isLandOnMenuEnabled) {
    currentView = boxSummaryViews.DETAILS
  } else if (showPostcode) {
    currentView = boxSummaryViews.POSTCODE
  } else if (showDeliverySlot) {
    currentView = boxSummaryViews.DELIVERY_SLOT
  } else if (showPortionsSizeView) {
    currentView = boxSummaryViews.PORTION_SIZE
  } else if (showDetailsView) {
    currentView = boxSummaryViews.DETAILS
  }

  return currentView
}

export { boxSummaryViews, getCurrentBoxSummaryView }
